import { render } from "./error.vue?vue&type=template&id=be4d9c82&scoped=true"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"

import "./error.vue?vue&type=style&index=0&id=be4d9c82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be4d9c82"]])

export default __exports__